<template lang="pug">
el-form.form(label-position='top', size='small')
    .card-dados-fazenda
        span.descricao Dados gerais da fazenda
        el-form-item
            .nome(slot='label')
                span Fundo
        el-form-item
            .nomeValor(slot='label')
                span {{ dadosFazenda.codigoFazenda }}
        el-form-item
            .fundo(slot='label')
                span Fazenda
        el-form-item
            .fundoValor(slot='label')
                span {{ dadosFazenda.nomeFazenda }}
        el-form-item
            .area(slot='label')
                span Área produtiva(ha)
        el-form-item
            .areaValor(slot='label')
                span {{ dadosFazenda.area }}
        el-form-item
            .areaColhida(slot='label')
        el-form-item
            .car(slot='label')
                span CAR
        el-form-item
            .carValor(slot='label')
                span {{ dadosFazenda.car }}
        el-form-item
            .municipio(slot='label')
                span Localidade
        el-form-item
            .municipioValor(slot='label')
                span {{ dadosFazenda.municipio + ' - ' + dadosFazenda.estado}}
        el-form-item
            .certificacao(slot='label')
                span Certificação
        el-form-item
            .certificacaoValor(slot='label')
                span {{ dadosFazenda.fazendaCertificada ? 'Bonsucro' : 'Não se aplica'}}

</template>

<script>

export default {
    name: 'CardDadosGeralFazenda',
    emits: [],
    props: {
        dadosFazenda: {
            type: Object,
            default: () => {}
        }
    }
};
</script>

<style lang="scss">
.card-dados-fazenda {
    background-color: var(--white);
    position: sticky;
    display:flex;
    width: 100%;
    height: 215px;
    left: 93px;
    top: 183px;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    .header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .descricao{
        position: absolute;
        width: 176px;
        height: 19px;
        left: 16px;
        top: 19px;

        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #3B3B3B;
    }

    label{
        font-family: 'Roboto';
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .nome{
        /* Nome */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 16px;
        top: 58px;
        font-weight: 500;
        color: #00413C;
    }
    .nomeValor{
        /* Nome Fazenda */
        position: absolute;
        width: 168px;
        height: 16px;
        left: 16px;
        top: 82px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .fundo{
        /* CAR */
        position: absolute;
        width: 69.8px;
        height: 16px;
        left: 331px;
        top: 58px;
        font-weight: 500;
        color: #00413C;
    }

    .fundoValor{
        /* Car Fazenda */
        position: absolute;
        width: 112px;
        height: 16px;
        left: 331px;
        top: 82px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .area{
        /* area */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 616px;
        top: 58px;
        font-weight: 500;
        color: #00413C;
    }

    .areaValor{
        /* area produtiva */
        position: absolute;
        width: 359px;
        height: 16px;
        left: 616px;
        top: 82px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .areaColhida{
        /* areaColhida */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 981px;
        top: 58px;
        font-weight: 500;
        color: #00413C;
    }

    .areaColhidaValor{
        /* areaColhida valor */
        position: absolute;
        width: 359px;
        height: 16px;
        left: 981px;
        top: 82px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .car{
        /* CAR */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 16px;
        top: 138px;
        font-weight: 500;
        color: #00413C;
    }

    .carValor{
        /* Car Fazenda */
        position: absolute;
        width: 359px;
        height: 16px;
        left: 16px;
        top: 162px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .municipio{
        /* municipio */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 443px;
        top: 138px;
        font-weight: 500;
        color: #00413C;
    }

    .municipioValor{
        /* municipio valor */
        position: absolute;
        width: 359px;
        height: 16px;
        left: 443px;
        top: 162px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .certificacao{
        /* certificacao */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 768px;
        top: 138px;
        font-weight: 500;
        color: #00413C;
    }

    .certificacaoValor{
        /* municipio valor */
        position: absolute;
        width: 359px;
        height: 16px;
        left: 768px;
        top: 162px;
        font-weight: 400;
        color: #3B3B3B;
    }

    .fornecedor{
        /* fornecedor */
        position: absolute;
        width: 149.35px;
        height: 16px;
        left: 1086px;
        top: 138px;
        font-weight: 500;
        color: #00413C;
    }

    .fornecedorValor{
        /* fornecedor valor */
        position: absolute;
        width: 359px;
        height: 16px;
        left: 1086px;
        top: 162px;
        font-weight: 400;
        color: #3B3B3B;
    }

}

.form {
        padding-bottom: 5px;
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
</style>
